import React from "react";
import PolicyPage from "./PolicyPage";

const PrivacyAndSecurity = () => {
  return <PolicyPage policyType="PrivacyPolicy" pageTitle="Privacy And Security" />;
};

export default PrivacyAndSecurity;